export { default } from './CarrosEletricosBannerF1';
